<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <div class="qr-code">
    <a
      v-bind="this.$browserDetect.isFirefox ? { target: '_blank' } : {}"
      :href="`lightning:${lnurl}`"
      download
    >
      <div class="qrcode-land">
        <lnbig-qr-code
          v-if="lnurl"
          :value="`lightning:${lnurl}`.toUpperCase()"
          :level="levelQrCode"
          :size="sizeQrCode"
          :class="{
            'qr-code-blur': opened || error || currentCountdown === 0,
            'd-inline-block': true,
          }"
        />
      </div>
    </a>
    <v-avatar
      v-if="lnurl && opened && !error"
      class="progress"
      color="green"
      :size="50"
    >
      <v-icon color="white" :size="30"> done </v-icon>
    </v-avatar>
    <v-avatar
      v-else-if="lnurl && error"
      class="progress"
      color="red"
      :size="50"
    >
      <v-icon color="white" :size="30"> error_outline </v-icon>
    </v-avatar>
  </div>
</template>

<script>
/**
 * TODO Подумать - где размещать сообщение об ошибке
 * TODO Lnurl & Prepayment - сделать через mixin
 */
import dbg from "debug";
import Countdown from "@/components/Mixin/Countdown";
import QrCode from "@/components/Mixin/QrCode";

const debug = dbg("lnbig:lnurl");

export default {
  name: "LnurlItem",
  mixins: [Countdown, QrCode],
  props: {
    lnurl: String,
    error: String,
    opened: Boolean,
  },
  mounted() {
    this.startCountdown();
  },
  watch: {
    lnurl() {
      this.startCountdown();
    },
    opened(newVal) {
      if (newVal) this.stopCountdown();
    },
  },
};
</script>

<style scoped>
.qrcode-land {
  background-color: #ffffff;
}

.qr-code {
  display: block;
  position: relative;
}

.qr-code-blur {
  opacity: 0.3;
}

.progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
